import { createSlice } from '@reduxjs/toolkit';
import { TaxState } from '../../../types/tax';

// Set the initial state values of the state object that this slice will manage
const INITIAL_STATE: TaxState = {
  isGetTaxPaymentPeriodsInProgress: false,
  isTaxPaymentPeriodsSuccess: false,
  taxPaymentPeriods: [],
  taxPaymentPeriodsErrorMsg: '',

  isCalculateTaxInProgress: false,
  isCalculateTaxSuccess: false,
  calculatedTaxData: {}, // raw data returned from  /calculateMultiPropertyTot
  calculatedTaxErrorMsg: '',

  preSelectedPeriod: undefined,

  taxFlowData: {
    selectedLicenses: [],
    reportingMethod: undefined,
  },
};

// Define the slice and generate actions, reducers with createSlice
export const taxSlice = createSlice({
  name: 'tax',
  initialState: INITIAL_STATE,
  reducers: {
    taxPaymentPeriodsStarted: (state) => {
      state.isGetTaxPaymentPeriodsInProgress = true;
      state.isTaxPaymentPeriodsSuccess = false;
      state.taxPaymentPeriodsErrorMsg = '';
    },
    taxPaymentPeriodSucceeded: (state, action) => {
      const { paymentPeriods, callback } = action.payload;
      state.isGetTaxPaymentPeriodsInProgress = false;
      state.isTaxPaymentPeriodsSuccess = true;
      state.taxPaymentPeriods = paymentPeriods;
      state.taxPaymentPeriodsErrorMsg = '';
      callback(state.taxPaymentPeriods);
    },
    taxPaymentPeriodFailure: (state, action) => {
      state.isGetTaxPaymentPeriodsInProgress = false;
      state.isTaxPaymentPeriodsSuccess = false;
      state.taxPaymentPeriods = [];
      state.taxPaymentPeriodsErrorMsg = action.payload;
    },
    calculateTaxStarted: (state) => {
      state.isCalculateTaxInProgress = true;
      state.isCalculateTaxSuccess = false;
      state.calculatedTaxErrorMsg = '';
    },
    calculateTaxSucceeded: (state, action) => {
      const data = action.payload;
      state.isCalculateTaxInProgress = false;
      state.isCalculateTaxSuccess = true;
      state.calculatedTaxData = data;
      state.calculatedTaxErrorMsg = '';
    },
    calculateTaxFailure: (state, action) => {
      state.isCalculateTaxInProgress = false;
      state.isCalculateTaxSuccess = false;
      state.calculatedTaxData = {};
      state.calculatedTaxErrorMsg = action.payload;
    },
    resetCalculateTax: (state) => {
      state.isCalculateTaxInProgress = false;
      state.isCalculateTaxSuccess = false;
      state.calculatedTaxErrorMsg = '';
    },
    resetTaxState: () => INITIAL_STATE,
    setPreSelectedTaxPeriod: (state, action) => {
      state.preSelectedPeriod = action.payload;
    },
    clearPreSelectedTaxPeriod: (state) => {
      state.preSelectedPeriod = undefined;
    },
    updateTaxFlowData: (state, action) => {
      state.taxFlowData = {
        ...state.taxFlowData,
        ...action.payload,
      };
    },
  },
});

// Export actions that were generated by createSlice
export const {
  taxPaymentPeriodsStarted,
  taxPaymentPeriodSucceeded,
  taxPaymentPeriodFailure,
  calculateTaxStarted,
  calculateTaxSucceeded,
  calculateTaxFailure,
  resetCalculateTax,
  resetTaxState,
  setPreSelectedTaxPeriod,
  clearPreSelectedTaxPeriod,
  updateTaxFlowData,
} = taxSlice.actions;

// Export combined reducer that was generated by createSlice
// (this is a single reducer which is a combination of all reducers in the slice... it basically puts them in a switch statement)
export default taxSlice.reducer;
